



























































































































import {ComponentInfo, NGLComponentInfo, SceneShot} from '@/store/shots'
import {ref, computed, defineComponent, unref, inject} from '@vue/composition-api'
import {MolRepresentation} from '@/models'
import {Stage} from 'ngl'

const components = {}
const props = {
  shot: {
    type: SceneShot,
    default: null,
  },
}
const NglComponentsList = defineComponent({
  name: 'NglComponentsList',
  components,
  props,
  setup(props: any, {emit}: any) {
    const molecules = computed(() => (props.shot as SceneShot).components)
    const moleculeSelected = ref(props.shot && props.shot.currentComponent ? props.shot.currentComponent : '')
    const representationSelectedIndex = ref(moleculeSelected ? 0 : -1)
    const stage = inject('NGLMainStage') as () => Stage

    const selectMolecule = (molecule: ComponentInfo) => {
      props.shot.setCurrentComponent(molecule.id)
      moleculeSelected.value = molecule.id
      const index = 0
      representationSelectedIndex.value = index
      emit('moleculeRepresentationSelected', {componentId: molecule.id, index})
    }

    const moleculeWrapperClasses = (molecule: ComponentInfo) => {
      const moleculeItemActive = moleculeSelected.value === molecule.id
      return {
        'molecule-item-active': moleculeItemActive,
      }
    }

    const toggleMoleculeVisibility = (molecule: ComponentInfo) => {
      if (stage()) {
        const newVal = molecule.componentParams.params.visible.value
        const nglComp = stage().compList.find(c => c.uuid === molecule.nglUuid)
        nglComp?.setVisibility(newVal)
        molecule.componentParams.setParam({name: 'visible', value: !newVal})
        // Also use white icon color, select icon based on param val
        // (just make that computed, based on param val)
      }
    }

    const getMoleculeIconClasses = (index: number) => {
      const lightenStep = Math.ceil(index + 1 /  4)
      const className = `text--lighten-${lightenStep}`

      return {[className]: true}
    }

    const removeMolecule = (index: number) => {
      if (molecules.value[index]) {
        const molecule = molecules.value[index]
        const component: NGLComponentInfo = {
          id: '', title: '', uuid: molecule.id,
        }
        emit('componentRemoved', {component, index})
      }
    }

    const isMoleculeSelected = (molecule: ComponentInfo) => {
      return unref(moleculeSelected) === molecule.id
    }

    const moleculeVisibleIcon = (molecule: ComponentInfo): string => {
      const nglComp = stage()?.compList.find(c => c.uuid === molecule.nglUuid)
      if (nglComp)
        return nglComp.visible ? 'mdi-eye-outline' : 'mdi-eye-off-outline'
      return 'mdi-eye-off-outline'
    }
    const moleculeVisibleIconColor = (molecule: ComponentInfo): string => {
      const nglComp = stage()?.compList.find(c => c.uuid === molecule.nglUuid)
      if (nglComp)
        return nglComp.visible ? 'white' : 'secondary'
      return 'secondary'
    }

    const representationVisible = (representation: MolRepresentation, molecule: ComponentInfo) => {
      const component = props.shot.components.find((c: ComponentInfo) => c.id === molecule.id)
      if (component) {
        const componentRepresentation = component.representations.find((r: MolRepresentation) => r.id === representation.id)
        if (componentRepresentation) {
          const repParamStore = component.representationParams[componentRepresentation.id]
          if (repParamStore)
            return repParamStore.params.visible.value
        }
      }
      return false
    }

    const selectRepresentation = (molecule: ComponentInfo, repIndex: number): void => {
      if (moleculeSelected.value !== molecule.id)
        selectMolecule(molecule)
      representationSelectedIndex.value = repIndex
      emit('moleculeRepresentationSelected', {componentId: molecule.id, index: repIndex})
    }

    const toggleRepresentationVisibility = (representation: MolRepresentation, molecule: ComponentInfo, repIndex: number) => {
      const component = props.shot.components.find((c: ComponentInfo) => c.id === molecule.id)
      if (component) {
        const componentRepresentation = component.representations.find((r: MolRepresentation) => r.id === representation.id)
        if (componentRepresentation) {
          const repParamStore = component.representationParams[componentRepresentation.id]
          if (repParamStore) {
            selectRepresentation(molecule, repIndex)
            repParamStore.setParam({name: 'visible', value: !repParamStore.params.visible.value})
          }
        }
      }
    }

    const representationVisibleIconColor = (representation: MolRepresentation, molecule: ComponentInfo): string => {
      return representationVisible(representation, molecule) ? 'white' : 'secondary'
    }

    const representationVisibleIcon = (representation: MolRepresentation, molecule: ComponentInfo): string => {
      return representationVisible(representation, molecule) ? 'mdi-eye-outline' : 'mdi-eye-off-outline'
    }

    const removeRepresentation = (molecule: ComponentInfo, index: number): void => {
      console.log(`NglComponentsList.removeRepresentation(${molecule.id}, ${index})`)
      emit('moleculeRepresentationRemoved', {componentId: molecule.id, index})
    }

    const representationSelected = (molecule: ComponentInfo, index: number) => {
      return (unref(moleculeSelected) === molecule.id && unref(representationSelectedIndex) === index)
    }

    return {
      molecules,
      moleculeSelected, moleculeWrapperClasses, selectMolecule, toggleMoleculeVisibility, getMoleculeIconClasses,
      removeMolecule, isMoleculeSelected, moleculeVisibleIcon, moleculeVisibleIconColor,
      representationVisible, toggleRepresentationVisibility, representationVisibleIcon, representationVisibleIconColor,
      removeRepresentation, selectRepresentation, representationSelected,
    }
  }
})

export default NglComponentsList
